"use strict";
/* eslint-disable no-eval */
Object.defineProperty(exports, "__esModule", { value: true });
exports.evalAndGet = exports.promisify = void 0;
function promisify(fn) {
    return (args) => new Promise((resolve, reject) => {
        fn(args, (error, data) => {
            if (error) {
                reject(error);
            }
            else {
                resolve(data);
            }
        });
    });
}
exports.promisify = promisify;
function evalAndGet(script, varName) {
    return eval(`${script};
    ${varName};`);
}
exports.evalAndGet = evalAndGet;
